
import { Children, cloneElement } from 'react';

const DEFAULT_PREFIX = 'om-';

const prefixClassName = (className, prefix = DEFAULT_PREFIX) => className && className.split(' ')
    .filter(c => c !== '')
    .map(name => name.substr(0, 3) !== prefix && name.charAt(0).toUpperCase() === name.charAt(0) && `${prefix}${name}` || name)
    .join(' ') || '';

const prefixChildren = (parseChildren, prefix = DEFAULT_PREFIX) => Children.map(parseChildren, (child) => {
    if (!child || !child.props) {
        return child;
    }
    const { className, children, ...restProps } = child.props;
    return (className || Children.count(children)) && cloneElement(child, {
        className: prefixClassName(className, prefix),
        ...restProps,
    }, Children.count(children) && prefixChildren(children) || children) || child;
});

export default (prefix = DEFAULT_PREFIX) => (target) => {
    const t = target;
    t.prototype.hiddenOriginalRender = t.prototype.render;
    t.prototype.render = function render() {
        const component = this.hiddenOriginalRender();
        if (!component || !component.props) {
            return component;
        }
        const { className, children, ...restProps } = component.props;
        return (className || Children.count(children)) && cloneElement(component, {
            className: prefixClassName(className, prefix),
            ...restProps,
        }, Children.count(children) && prefixChildren(children, prefix) || children) || component;
    };
};



// WEBPACK FOOTER //
// ./src/SharedComponents/prefixClassNames.js